import { getGlobalImpTransactions, getGlobalTransactionSummary, getGlobalTransactions } from "../types/global_transactions_types";


export const getGlobalTransactionsRequest = (payload) => ({
    type: getGlobalTransactions.GET_GLOBAL_TRANSACTIONS_REQUEST,
    payload,
});
export const getGlobalTransactionsSuccess = (payload) => ({
    type: getGlobalTransactions.GET_GLOBAL_TRANSACTIONS_SUCCESS,
    payload,
});
export const getGlobalTransactionsError = (payload) => ({
    type: getGlobalTransactions.GET_GLOBAL_TRANSACTIONS_ERROR,
    payload,
});

export const getGlobalImpTransactionsRequest = (payload) => ({
    type: getGlobalImpTransactions.GET_GLOBAL_IMP_TRANSACTIONS_REQUEST,
    payload,
});
export const getGlobalImpTransactionsSuccess = (payload) => ({
    type: getGlobalImpTransactions.GET_GLOBAL_IMP_TRANSACTIONS_SUCCESS,
    payload,
});
export const getGlobalImpTransactionsError = (payload) => ({
    type: getGlobalImpTransactions.GET_GLOBAL_IMP_TRANSACTIONS_ERROR,
    payload,
});

export const getGlobalTransactionSummaryRequest = (payload) => ({
    type: getGlobalTransactionSummary.GET_GLOBAL_TRANSACTIONS_SUMMARY_REQUEST,
    payload,
});
export const getGlobalTransactionSummarySuccess = (payload) => ({
    type: getGlobalTransactionSummary.GET_GLOBAL_TRANSACTIONS_SUMMARY_SUCCESS,
    payload,
});
export const getGlobalTransactionSummaryError = (payload) => ({
    type: getGlobalTransactionSummary.GET_GLOBAL_TRANSACTIONS_SUMMARY_ERROR,
    payload,
});